/**
 * Converting the profile's box format into what three.js and Rapier expect.
 */

import type { Box } from '../game/profile/types';

/** Rapier takes half-extents; the profile format uses full sizes. */
export function halfExtents(box: Box): [number, number, number] {
  return [box.size.x / 2, box.size.y / 2, box.size.z / 2];
}

export function boxPosition(box: Box): [number, number, number] {
  return [box.center.x, box.center.y, box.center.z];
}
